module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('partners'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.showStatsCount > 4) ? _c('div', {
    staticClass: "stats content-layout"
  }, [_c('div', {
    staticClass: "lookups column column__xs"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("thousand")(_vm.newTotalLookups)) + "\n                ")]), _vm._v("\n                søgn. i alt\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "lookups column column__xs"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("thousand")(_vm.newTotalVehicles)) + "\n                ")]), _vm._v("\n                køretøjer\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "lookups column column__xs"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("thousand")(_vm.newLookupsYesterday)) + "\n                ")]), _vm._v("\n                søgn. i går\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "lookups column column__xs"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("thousand")(_vm.newLookupsToday)) + "\n                ")]), _vm._v("\n                søgn. i dag\n            ")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.showStatsCount > 9) ? _c('div', [_c('a', {
    attrs: {
      "href": "https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n                Lead\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "opacity": ".15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright-line"
  }, [_vm._v("\n                2019 ©\n                "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.showStats()
      }
    }
  }, [_vm._v("\n                    NrPladeTjek.dk\n                ")]), _vm._v("\n                  |  \n                Udviklet og drevet af "), _c('a', {
    attrs: {
      "href": "https://deveo.dk",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Deveo ApS")])]), _vm._v(" "), _c('div', {
    staticClass: "copyright-line mobile"
  }, [_vm._v("\n                2019 ©\n                "), _c('span', {
    on: {
      "click": function($event) {
        _vm.showStatsCount = _vm.showStatsCount + 1
      }
    }
  }, [_vm._v("\n                    NrPladeTjek.dk\n                ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Udviklet og drevet af "), _c('a', {
    attrs: {
      "href": "https://deveo.dk",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Deveo ApS")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "opacity": ".5"
    }
  }, [_vm._v("\n                NrPladeTjek.dk er ikke ansvarlige for fejl i de viste oplysninger, da alle oplysninger er hentet fra offentlige registre.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:kontakt@nrpladetjek.dk"
    }
  }, [_vm._v("Kontakt os")]), _vm._v(" ved spørgsmål eller feedback om vores side.\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4b551a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/components/footer.vue
// module id = 361
// module chunks = 1